import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { BottomNavComponent } from '../bottom-nav/bottom-nav.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import {
    MatDialog,
    MatDialogModule
} from '@angular/material/dialog';

export type BottomSheetStep =
    | 'SHARE'
    | 'RECEIVER'
    | 'NEW_RECIPIENT'
    | 'READY';


@Component({
    selector: 'app-share-details',
    standalone: true,
    imports: [CommonModule, BottomNavComponent, MatExpansionModule, MatCheckboxModule, MatRadioModule, MatButtonModule, MatDialogModule],
    templateUrl: './share-details.component.html',
    styleUrls: ['./share-details.component.scss']
})
export class ShareDetailsComponent implements OnInit {
    private _bottomSheetRef =
        inject<MatBottomSheetRef<ShareDetailsComponent>>(MatBottomSheetRef);
    readonly dialog = inject(MatDialog);

    currentStep: BottomSheetStep = 'SHARE';

    stepBackMap: Record<BottomSheetStep, BottomSheetStep | null> = {
        SHARE: null,
        RECEIVER: 'SHARE',
        NEW_RECIPIENT: 'SHARE',
        READY: 'RECEIVER',
    };

    completedSections = {
        personal: false,
        insurance: false,
        reason: false,
        meds: false,
        imaging: false
    };

    constructor(
        private router: Router
    ) { }


    ngOnInit(): void {

    }

    saveSelection(section: keyof typeof this.completedSections) {
        this.completedSections[section] = true;
        // Add logic here to close the panel or move to next
    }

    showBackButton(): boolean {
        return this.stepBackMap[this.currentStep] !== null;
    }

    onBack() {
        const prev = this.stepBackMap[this.currentStep];
        if (prev) {
            this.currentStep = prev;
        }
    }

    navigate(route: string): void {
        this._bottomSheetRef.dismiss();
        this.router.navigate([route]);
    }

    openLink(event: MouseEvent): void {
        this._bottomSheetRef.dismiss();
        event.preventDefault();
    }

    closeBottomSheet() {
        this._bottomSheetRef.dismiss();
    }

    openConfirmationDialog() {
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            panelClass: ['confirmation-modal'],
            backdropClass: 'confirmation-modal-backdrop',
            position: {
                top: '128px',
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
        });
    }

    sendSecurely(): void {
        this._bottomSheetRef.dismiss();

        this._bottomSheetRef.afterDismissed().subscribe(() => {
            this.router.navigate(['/final']);
        });
    }

}
